"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var Actions_1 = require("./Actions");
exports.Redfast = {
    createActions: function (config) {
        if (typeof window !== undefined) {
            core_1.AuthStore.init({});
            window.FoxRedfast = new Actions_1.RedfastActions(config);
            core_1.logInfo("Redfast SDK", "Actions Initialized");
        }
    },
};
//# sourceMappingURL=index.js.map